<template>
  <div class="meal-tab-page meal-order-page">
    <div class="meal-receive" v-if="hasAction">
      <p>
        <van-button
          v-if="delegateable"
          round
          type="warning"
          @click="handleDelegaterPick"
          >邀请别人代领</van-button
        >
      </p>
      <p>
        <van-button
          v-if="delegatedInfo"
          round
          type="warning"
          @click="handleCancelDelegate"
          >已邀请【{{ delegatedInfo.baileeName }}】代领
          <br /><br />点击取消</van-button
        >
      </p>
      <p>
        <van-button v-if="takeable" round type="info" @click="handleTake"
          >一键领取</van-button
        >
      </p>
    </div>
    <div class="meal-result-success" v-else-if="hasTaked">
      <div class="result" :class="resultTakeId ? 'result-success' : ''">
        <van-icon name="certificate" v-if="resultTakeId" />
        {{ resultTakeId ? '领取成功' : '已领取加班餐' }}
      </div>
      <div
        class="result-note"
        :key="key"
        v-for="(items, key) in mealTakeResultMap"
      >
        <div class="title van-hairline--bottom">
          {{ !items[0].baileeName ? '我' : `代领【${key}】` }}的加班餐
        </div>

        <div class="meal-menu" v-if="items.length">
          <dl :key="item.id" v-for="item in items">
            <dt>{{ item.menuName }}</dt>
            <dd>{{ item.menuDetail }}</dd>
          </dl>
        </div>
      </div>
      <div class="time time1">{{ time }}</div>
      <div class="time time2">{{ time }}</div>
      <div class="time time3">{{ time }}</div>
    </div>
    <div class="meal-order-tip" v-else-if="!hasWaitTake">
      <div class="noDataImg"></div>
      {{ tipTxt }}
    </div>
    <!-- <div class="meal-result-fail">
      <div class="result"><van-icon name="close" /> 加班餐已领取</div>
    </div> -->
    <!-- <van-dialog
      v-model="delegateDialogVisible"
      title="请选择代领人"
      show-cancel-button
    >
      <van-field
        readonly
        clickable
        name="delegaterId"
        :value="delegaterId"
        placeholder="请选择代领人"
        right-icon="arrow"
        @click="handleDelegaterPick"
      />
    </van-dialog> -->
    <van-popup position="bottom" v-model="delegatePickerVisible">
      <van-search placeholder="请输入代领人" v-model="delegaterKey" />
      <van-picker
        cancel-button-text="取消"
        title="选择代领人"
        show-toolbar
        :loading="delegaterListloading"
        :columns="delegaterList"
        @confirm="handleConfirmPicker"
        @cancel="delegatePickerVisible = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import format from 'date-fns/format';
import * as mealApi from '@api/meal';
import axios from 'axios';

import {
  Button,
  Icon,
  Image,
  Popup,
  Toast,
  Dialog,
  Loading,
  Tabs,
  Tab,
  Rate,
  Grid,
  GridItem,
  Form,
  Field,
  Search,
  Picker,
} from 'vant';

// 一次性引入常用组件
[
  Button,
  Icon,
  Image,
  Popup,
  Toast,
  Dialog,
  Loading,
  Tabs,
  Tab,
  Rate,
  Grid,
  GridItem,
  Form,
  Field,
  Search,
  Picker,
].forEach(item => {
  if (item.install) {
    Vue.use(item);
  }
});

export default {
  inject: ['setActive'],
  data() {
    return {
      time: '',
      timer: '',
      delegateDialogVisible: false,
      delegatePickerVisible: false,
      delegaterId: '',
      delegaterKey: '',
      delegaterList: [], // 带领人列表
      delegaterSearchTimer: null,
      delegaterListloading: false,
      takeable: false, // 是否可领取，自己有未领取的订餐或者别人有让你代领的切未领取的订餐的时候，领取按钮可用
      delegateable: false, // 是否可委托别人代领，自己有待领取的订餐时，可委托
      mealInfo: [], // 加班餐领取信息
      mealIdList: [], // 可取餐列表
      delegatedInfo: null, // 待领取：委托的信息
      hasTaked: false, // 是否有已被领取的订餐
      mealTakeResultMap: {}, // 领取结果
      hasWaitTake: true, // 是否有待领加班餐
      resultTakeId: '',
      tipTxt: '无待领取加班餐~',
    };
  },
  created() {
    this.setActive('order');
    this.startTime();
  },
  watch: {
    delegaterKey() {
      if (this.delegaterSearchTimer) {
        clearTimeout(this.delegaterSearchTimer);
      }
      this.delegaterSearchTimer = setTimeout(() => {
        this.getDelegaterList();
      }, 500);
    },
  },
  computed: {
    hasAction() {
      return this.takeable || this.delegateable || this.delegatedInfo;
    },
  },
  async mounted() {
    await this.updateView();

    // const resultList = [
    //   {
    //     id: 38,
    //     mealTakeStatusCode: 'HAS_TAKEN_BAILEE',
    //     mealTakeStatusDesc: '已领取：受托',
    //     personCode: 'DZB1995',
    //     personName: '张博',
    //     userId: null,
    //     menuId: 34,
    //     menuName: 'A',
    //     menuDetail: '蒸熊掌,小葱拌豆腐,烤鸭,番茄鸡蛋,水果,番茄鸡蛋,水果',
    //     orderTime: '2020-09-08 13:46:16',
    //     baileeCode: 'D58L83',
    //     baileeName: '狸大大',
    //     takeId: 6,
    //     takeTime: '2020-09-08 16:05:18',
    //   },
    // ];
    // this.setMealTakeResultMap(resultList);
  },
  methods: {
    async updateView(takeId) {
      await this.getMealTakeInfo();
      this.setMealInfo(takeId);
    },
    async getMealTakeInfo() {
      const res = await mealApi.mealTakeInfo().catch(err => {
        if (err.code === '500') {
          this.hasWaitTake = false;
          this.tipTxt = err.message;
        } else {
          Toast.fail(err.message);
        }
        // Toast.fail(err.message);
        // this.mealInfo = [
        //   {
        //     id: 2,
        //     mealTakeStatusCode: 'HAS_TAKEN_OWNER',
        //     mealTakeStatusDesc: '已领取：自己',
        //     personCode: 'test1111110',
        //     personName: '兰兰',
        //     userId: null,
        //     menuId: 8,
        //     menuName: 'B',
        //     menuDetail: '土豆丝,莲藕,花菜,水果',
        //     orderTime: '2020-09-02 16:38:21',
        //     baileeCode: null,
        //     baileeName: null,
        //     takeId: null,
        //     takeTime: '2020-09-02 11:43:42',
        //   },
        //   {
        //     id: 3,
        //     mealTakeStatusCode: 'WAIT_TAKE_OWNER',
        //     mealTakeStatusDesc: '待领取：自己',
        //     personCode: 'test1111110',
        //     personName: '兰兰',
        //     userId: null,
        //     menuId: 5,
        //     menuName: 'A',
        //     menuDetail: '土豆丝,莲藕,花菜,水果',
        //     orderTime: '2020-09-02 12:38:21',
        //     baileeCode: null,
        //     baileeName: null,
        //     takeId: null,
        //     takeTime: null,
        //   },
        //   {
        //     id: 4,
        //     mealTakeStatusCode: 'WAIT_TAKE_BAILOR',
        //     mealTakeStatusDesc: '待领取：委托',
        //     personCode: 'test1111110',
        //     personName: '兰兰',
        //     userId: null,
        //     menuId: 6,
        //     menuName: 'A',
        //     menuDetail: '土豆丝,莲藕,花菜,水果',
        //     orderTime: '2020-09-02 12:00:21',
        //     baileeCode: 'T1314',
        //     baileeName: '兰兰',
        //     takeId: null,
        //     takeTime: null,
        //   },
        // ];
      });
      if (res) {
        this.mealInfo = res.mealList;
      }
    },
    setMealInfo(takeId) {
      this.mealIdList = [];
      this.delegateable = false;
      this.takeable = false;
      this.delegatedInfo = null;

      this.mealInfo.forEach(item => {
        // 待领取：自己；
        if (['WAIT_TAKE_OWNER'].includes(item.mealTakeStatusCode)) {
          this.delegateable = true;
        }
        // 待领取：自己；待领取：受托
        if (
          ['WAIT_TAKE_OWNER', 'WAIT_TAKE_BAILEE'].includes(
            item.mealTakeStatusCode
          )
        ) {
          this.takeable = true;
          this.mealIdList.push(item.id);
        }
        // 待领取：委托
        if (['WAIT_TAKE_BAILOR'].includes(item.mealTakeStatusCode)) {
          this.delegatedInfo = item;
          this.mealIdList.push(item.id);
        }
        // 已领取：自己; 已领取：受托; 已领取：委托
        if (
          ['HAS_TAKEN_OWNER', 'HAS_TAKEN_BAILEE', 'HAS_TAKEN_BAILOR'].includes(
            item.mealTakeStatusCode
          )
        ) {
          this.hasTaked = true;
          this.getTakeResult(takeId);
        }
      });
    },
    startTime() {
      this.stopTime();
      this.timer = setInterval(() => {
        this.time = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      }, 1000);
    },
    stopTime() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    /**
     * 领取结果
     */
    async getTakeResult(takeId) {
      const res = await mealApi
        .mealTakeResult({
          takeId,
        })
        .catch(err => {
          Toast.fail(err.message);
        });
      if (res && res.takeList) {
        const mealList = [];
        res.takeList.forEach(take => {
          take.mealList.forEach(meal => {
            mealList.push(meal);
          });
        });
        if (mealList.length) {
          this.setMealTakeResultMap(mealList);
        } else if (this.mealInfo.length) {
          this.setMealTakeResultMap(this.mealInfo);
        }
      }
      this.resultTakeId = takeId;
    },
    /**
     * 设置加班餐结果列表
     */
    setMealTakeResultMap(resultList) {
      this.mealTakeResultMap = {};
      resultList.forEach(item => {
        // 归属人
        const key = item.personName;
        if (!this.mealTakeResultMap[key]) {
          this.mealTakeResultMap[key] = [];
        }
        this.mealTakeResultMap[key].push(item);
      });
    },
    /**
     * 取消代领
     */
    handleCancelDelegate() {
      mealApi
        .mealCancelBailee({
          mealIdList: this.mealIdList,
        })
        .then(() => {
          Toast.success('已取消委托！');
          this.updateView();
        })
        .catch(err => {
          Toast.fail(err.message);
        });
    },
    /**
     * 一键领取
     */
    handleTake() {
      Dialog.alert({
        message: '请务必至发餐员当面领餐，出示领餐结果页',
        theme: 'round-button',
      }).then(() => {
        mealApi
          .mealTake({
            mealIds: this.mealIdList,
          })
          .then(res => {
            Toast.success('领取成功！');
            this.updateView(res.takeId);
          })
          .catch(err => {
            Toast.fail(err.message);
          });
      });
    },
    /**
     * 更新代领人
     */
    async getDelegaterList() {
      if (this.delegaterListSource) {
        this.delegaterListSource.cancel();
      }
      this.delegaterListSource = axios.CancelToken.source();
      this.delegaterListloading = true;
      const res = await mealApi.searchPerson(
        {
          key: this.delegaterKey,
        },
        {
          cancelToken: this.delegaterListSource.token,
        }
      );
      res.list.forEach(item => {
        item.text = `${item.personName}（${item.personCode}）`;
      });
      this.delegaterListloading = false;
      this.delegaterList = res.list;
    },
    /**
     * 提交委托
     */
    async handleConfirmPicker(user) {
      this.delegatePickerVisible = false;
      const res = await mealApi
        .mealBailee({
          baileeCode: user.personCode,
          baileeName: user.personName,
          mealIdList: this.mealIdList,
        })
        .catch(err => {
          Toast.fail(err.message);
        });
      if (res) {
        Toast.success('委托成功！');
        this.updateView();
      }
    },
    handleDelegaterPick() {
      this.delegatePickerVisible = true;
    },
  },
};
</script>

<style lang="scss">
// .noDataImg {
//   height: 262px;
//   margin-bottom: 20px;
//   background: url('../../assets/image/no_arrange.png') no-repeat center;
// }
.noDataImg {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
  background: url(https://web-data.zmlearn.com/image/kY3xqpeL2t4RRGdd43Sqdx/meal_no_result.png) no-repeat center
    center;
  background-size: cover;
  margin: 0 auto;
}
.meal-order-tip {
  font-size: 32px;
  text-align: center;
  color: #999;
  padding-top: 100px;
}
.meal-receive {
  text-align: center;
  .van-button {
    margin-top: 40px;
    width: 120px;
    border-radius: 60px;
    height: 120px;
  }
}
.meal-result-success {
  padding: 0 60px;
  position: relative;
  .result {
    font-size: 60px;
    .van-icon {
      vertical-align: middle;
    }
  }
  .result-success {
    color: #07c160;
  }
  .result-note {
    margin-top: 50px;
  }
  .title {
    padding-bottom: 16px;
    font-size: 48px;
    color: #ff976a;
  }
  .meal-menu {
    margin-top: 16px;
    line-height: 60px;
    dl {
      overflow: hidden;
      margin-bottom: 20px;
    }
    dt {
      float: left;
      color: #1989fa;
    }
    dt {
      font-size: 60px;
    }
    dd {
      margin-left: 80px;
      font-size: 40px;
      span {
        margin-left: 12px;
      }
    }
  }
  .time {
    position: absolute;
    left: 0;
    top: 0;
    color: #eee;
    font-size: 64px;
    transform: rotate(-20deg);
    z-index: -1;
    line-height: 4;
    white-space: nowrap;
  }
  .time1 {
    top: 0;
    left: 50px;
  }
  .time2 {
    top: 380px;
    left: -100px;
  }
  .time3 {
    top: 600px;
    left: 160px;
  }
}
.meal-result-fail {
  padding: 0 100px;
  .result {
    font-size: 60px;
    color: #ee0a24;
    .van-icon {
      vertical-align: middle;
    }
  }
}
</style>
